const addToCartButton = document.getElementById("product-add-to-cart");
const is_gift_card = document.getElementById("isGiftCard").value;
const is_subscription = Number(document.getElementById("is_subscription").value) > 0;
is_gift_card === "true" || is_subscription === true
  ? (addToCartButton.disabled = false)
  : (addToCartButton.disabled = true);

function checkDeliveryDate(input) {
  const Selectors = {
    RECHARGE_WIDGET: '#subscription-widget',
    SELLING_PLAN_RADIO_CHECKED:
      'input[name^="selling_plan_"][type="radio"]:checked',
  };
  if (is_subscription) {
    const selectedPurchaseOption = document.querySelector(`${Selectors.RECHARGE_WIDGET} ${Selectors.SELLING_PLAN_RADIO_CHECKED}`);
    if (!selectedPurchaseOption) {
      addToCartButton.disabled = false;
      return;
    }
    const isOtp = selectedPurchaseOption.value === "onetime" ? true : false;
    if (isOtp) {
      addToCartButton.disabled = input.value.trim() === "";
    } else {
      addToCartButton.disabled = false;
    }
  } else {
    addToCartButton.disabled = input.value.trim() === "";
  }
}

function initializeObserver(input) {
  const observer = new MutationObserver(() => {
    checkDeliveryDate(input);
  });

  observer.observe(input, {
    attributes: true,
    attributeFilter: ["value"],
  });
  checkDeliveryDate(input);
}

function detectElementAdded(selector, callback) {
  const observer = new MutationObserver(() => {
    const element = document.querySelector(selector);
    if (element) {
      observer.disconnect();
      callback(element);
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

detectElementAdded('[data-ff-product-calendar][calendar-location="product-template"] input[name="delivery_date_input"]', initializeObserver);
